export var PanelsKeys;
(function (PanelsKeys) {
    PanelsKeys["guard_zones"] = "guard_zones";
    PanelsKeys["simple_view"] = "simple_view";
    PanelsKeys["boiler_heating_circuits"] = "boiler_heating_circuits";
    PanelsKeys["boiler_heating_modes"] = "boiler_heating_modes";
    PanelsKeys["heating_circuits"] = "heating_circuits";
    PanelsKeys["heating_modes"] = "heating_modes";
    PanelsKeys["thermometers"] = "thermometers";
    PanelsKeys["sensors"] = "sensors";
    PanelsKeys["custom_controls"] = "custom_controls";
    PanelsKeys["guard_control"] = "guard_controls";
    PanelsKeys["rf_indicators"] = "rf_indicators";
    PanelsKeys["vehicle_custom_controls"] = "vehicle_custom_controls";
    PanelsKeys["vehicle_controls"] = "vehicle_controls";
})(PanelsKeys || (PanelsKeys = {}));
export const panel_key = [
    PanelsKeys.vehicle_controls,
    PanelsKeys.vehicle_custom_controls,
    PanelsKeys.heating_circuits,
    PanelsKeys.boiler_heating_circuits,
    PanelsKeys.heating_modes,
    PanelsKeys.boiler_heating_modes,
    PanelsKeys.thermometers,
    PanelsKeys.sensors,
    PanelsKeys.rf_indicators,
    PanelsKeys.custom_controls,
    PanelsKeys.guard_zones,
    PanelsKeys.guard_control,
    PanelsKeys.simple_view,
];
